<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">坐席管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">坐席列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addkf" type="primary">添加坐席</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除坐席</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    :placeholder="tstext"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table rowKey="aid" :row-selection="{ onChange: onSelectChange}" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="action" slot-scope="text,record" class="operate">
                        <!-- <a href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 跟进</a> -->
                        <!-- <a-switch checked-children="开" un-checked-children="关" default-checked /> -->
                        <a href="javascript:;" @click="edituser(record.aid)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.aid)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'aid',key: 'aid',width:100},
    {title: '账号',dataIndex: 'username',key: 'username'},
    {title: '姓名',dataIndex: 'name',key: 'name'},
    {title: '手机',dataIndex: 'telephone',key: 'telephone'},
    {title: '角色',dataIndex: 'group_title',key: 'group_title'},
    {title: '项目',dataIndex: 'item_title',key: 'item_title'},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },width:160},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            tstext:"请输入要搜索用户名或手机",
            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            size:10,
            totalpage:"",
            pageshow:false,
            pagination:{},
            currentpagination:"",
            addvisible:false,
            tablex:'100%',
            disabled:true,
            delids:"",

            searchtext:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:""
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){
        this.fetch()

        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };
    },
    methods:{

        // 搜索
        onSearch(){

            this.fetch()
        },
        // 编辑
        edituser(id){
            this.$router.push({path:'/edituser',query:{ id:id}});
        },
        // 添加客服
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/system/deladmin',{
                aids:id
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        addkf(){
            this.$router.push('/adduser');
            // this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/kefu/addcustomerservice',{
                username: this.username
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        handleCancel(){
            this.addvisible=false
        },
        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/system/adminlist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/userlist.vue